import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=6d45fee8&scoped=true"
import script from "./MainWrapper.vue?vue&type=script&lang=js"
export * from "./MainWrapper.vue?vue&type=script&lang=js"
import style0 from "./MainWrapper.vue?vue&type=style&index=0&id=6d45fee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45fee8",
  null
  
)

export default component.exports